export enum Locales {
  NlNL = 'nl-NL',
  EnUS = 'en-US',
  EsES = 'es-ES',
  DeDE = 'de-DE',
}

export const fallbackLocale = Locales.EnUS;
